export enum TabFilterType {
  ALL = 'all',
  DONE = 'done',
  SKIP = 'skipped',
  FAIL = 'failed',
}
